import { useQuery } from "@tanstack/react-query";
import { extractPaginatedCollection } from "../../utils/apiResponse";

async function getCatalogs({
  callApiWithWorker,
  language,
  pageIndex,
  pageSize,
  signal,
}) {
  const url =
    `/dataset-offers?language=${encodeURIComponent(language)}` +
    `&page=${pageIndex}&size=${pageSize}`;

  const res = await callApiWithWorker(url, { method: "GET", signal });

  const statusCode = res?.statusCode ?? res?.data?.statusCode;

  if (statusCode && statusCode >= 400) {
    throw new Error(`Dataset-offers request failed (${statusCode})`);
  }

  return extractPaginatedCollection(res);
}

export function useGetCatalog({
  callApiWithWorker,
  language,
  pageIndex,
  pageSize,
}) {
  return useQuery({
    queryKey: ["datasetOffers", language, pageIndex, pageSize],
    queryFn: ({ signal }) =>
      getCatalogs({
        callApiWithWorker,
        language,
        pageIndex,
        pageSize,
        signal,
      }),
    enabled:
      Boolean(callApiWithWorker) &&
      Boolean(language) &&
      Number.isInteger(pageIndex) &&
      Number.isInteger(pageSize),
    staleTime: 60_000,
    gcTime: 5 * 60_000,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });
}
